import { Component,EventEmitter, Input, SimpleChanges, } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { GlobalService } from '../../service/global.service';
import { NgxStarsModule } from 'ngx-stars';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
declare var Swiper: any
@Component({
  selector: 'app-home-lawyer-section',
  standalone: true,
  imports: [NgxStarsModule, CommonModule,RouterModule],
  templateUrl: './home-lawyer-section.component.html',
  styleUrl: './home-lawyer-section.component.scss'
})
export class HomeLawyerSectionComponent {


  @Input()
  heading = new EventEmitter<any>();

  @Input() data!: string;

  astroList: Array<any> = [
  ];
  moduleName: any = "CHAT";
  userId: any = null;
  searchQuery: any = "";
  pageNo: number = 0;
  pageSize: number = 12;

  swiper: any;

  constructor(private http: HttpService, private gS: GlobalService) {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && !changes['data'].firstChange) {
      console.log('Child received new param:', this.data);
      this.getData();
    }
  }

  getData() {
    this.http.getAstroList(this.gS.timeZone, this.moduleName, this.userId, this.searchQuery, this.pageNo, this.pageSize).subscribe((data) => {
      let value = data?.data;
      value.forEach((item: any) => {
        if (item?.expertiseArea) {
          item.expertiseArea = item?.expertiseArea.split(",");
        }
      });
      this.astroList=value;

      setTimeout(() => {
        this.initializeSwiper();
      }, 500);
      // console.log(this.astroList, "astro");
    }, (error) => {
      console.log(error);
    });
  }

  ngAfterViewInit(): void {



  }


  initializeSwiper() {
    this.swiper = new Swiper(".mySwiper3", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 8,
        },
      },
    });

  }



}
